import * as React from 'react';
import { connect } from 'react-redux';
import { getNextStep, getOverview } from '../../../../actions/claimHistoryActionsV2'
import { Card } from 'react-bootstrap';
import ClaimsProgressBar from '../ClaimHistoryComponents/ClaimsProgressBar';
import { isMobile } from 'react-device-detect';
import { showRepairsTakingLonger } from '../../../../actions/modalActions';
import { HashLink as Link } from 'react-router-hash-link';
import { CLAIM_HISTORY_V2, GOOGLE_MAPS_BASE_URL } from '../../../../routes/routes';
import ClaimsNextStep from '../ClaimHistoryComponents/ClaimsNextStep';

class Repairs extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            repairs: "active"
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleShowRepairsTakingLong = this.handleShowRepairsTakingLong.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleToggleCompleted = this.handleToggleCompleted.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.handleDirectionsClick = this.handleDirectionsClick.bind(this);
    }

    async handleClick() {
        this.props.handleGetNextStep();

    }

    async handleShowRepairsTakingLong() {
        this.props.handleRepairsTakingLonger();
    }

    async handleToggle() {
        this.setState({ repairs: "active" });
    }

    async handleToggleCompleted() {
        this.setState({ repairs: "inactive" });
    }

    async handleBackClick() {
        this.props.handleClaimsBackClick();
    }

    handleDirectionsClick() {
        var url = GOOGLE_MAPS_BASE_URL;
        window.open(GOOGLE_MAPS_BASE_URL + this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreLat + ',' + this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreLong, '_blank');
    }

    getFormatAssesmentDate(date: string) {
        if (date) {
            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var stringDate = date.split('T')[0];
            var formatedDate = new Date(stringDate);
            var fullFormatedDate = formatedDate.getDate().toString() + " " + monthNames[formatedDate.getMonth()] + " " + formatedDate.getFullYear().toString();
            return fullFormatedDate;
        } 
        return "Not Found";
    }

    render() {
        const scrollWithOffset = (el) => {
            const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
            const yOffset = -90;
            window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
        }
        const stepsList = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.overallEstProgressBar !== null).length > 0
        let nrToUse = -1
        if (this.props.claimSubmit.claimProgress) {
            for (var i = 0; i < this.props.claimSubmit.claimProgress.claimSteps.length - 1; i++) {
                if (this.props.claimSubmit.claimProgress.claimSteps[i + 1].claimStepDescription.toLowerCase() !== this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase()) {
                    nrToUse += 1
                    if (this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase() === this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase()) {
                        break;
                    }
                }
            }
        }
        let repairStepName = ""
        let repairStepDescription = ""
        switch (this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairStatus.toLowerCase()) {
            case "repair authorisation":
                repairStepDescription = "The repairer will start with repairs on your car ASAP";
                repairStepName = "We've authorised the repairs";
                break;
            case "booking confirmation":
                repairStepDescription = "Your car has been booked in for repairs";
                repairStepName = "Car booked in";
                break;
            case "vehicle in shop":
                repairStepDescription = "Your car is now at the repairers' shop";
                repairStepName = "Car with repairer";
                break;
            case "disassembly":
                repairStepDescription = "We're stripping your car in preparation for repairs";
                repairStepName = "It's coming apart";
                break;
            case "waiting for parts":
                repairStepDescription = "The parts have been ordered and on their way";
                repairStepName = "We're waiting for parts";
                break;
            case "structure repairs":
                repairStepDescription = "The repairer is repairing the structure of your car";
                repairStepName = "Structural repair is underway";
                break;
            case "body repairs":
                repairStepDescription = "The repairer is busy fixing all the dings and bumps";
                repairStepName = "Body repairs are underway";
                break;
            case "paint":
                repairStepDescription = "Your car is currently getting a fresh coat of paint";
                repairStepName = "We're painting today";
                break;
            case "reassembly":
                repairStepDescription = "Your car is being re-assembled";
                repairStepName = "It's all coming together";
                break;
            case "detailing":
                repairStepDescription = "Your car is in the quality control bay, and we won’t release it until it's a-okay";
                repairStepName = "It's all in the detail";
                break;
            case "collection":
                repairStepDescription = "Yay! Your car is ready for collection";
                repairStepName = "It's all yours";
                break;
            default:
                break;
        }
        return (
            <>
                <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                <div id="Repairs">
                    {stepsList && !this.props.claimSubmit.selectedClaimProgressStep.isComplete &&
                        <Card className="content-box-padding-20px-with-box-shadow mb-15px">
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <ClaimsProgressBar />
                                </div>
                            </div>
                        </Card>
                    }
                    {!this.props.claimSubmit.selectedClaimProgressStep.isComplete && <Card className="content-box-padding-20px-with-box-shadow">
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="claims-noc-step-header-icon-area">
                                        {(!this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <img src={"/my-policy/Images/Claims/Numbers/" + nrToUse + "-red.png"} alt={"Step " + nrToUse} title={"Step" + nrToUse} />}
                                    </div>
                                    <div className="col nopa claims-noc-step-header-title-area">
                                        <h3>Repairs</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 nopa mt-10px">
                                <p className="font-weight-500 mb-0px">Time to give your wheels some TLC. <br /><br />
                                    {!isMobile &&
                                        <span>Scroll down to the<Link className="text-red" to={CLAIM_HISTORY_V2 + "#claimFAQ"} scroll={el => scrollWithOffset(el)}> <b className="text-underline">FAQ’s</b></Link> for more info.</span>
                                    }
                                    {isMobile &&
                                        <span>Scroll down to the<Link className="text-red"> <b>FAQ’s</b></Link> for more info.</span>
                                    }
                                </p>
                                <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                            </div>
                            {repairStepName && repairStepDescription &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col-12 nopa">
                                            <p className="card-subheading mb-0px">Where we’re at</p>
                                        </div>
                                        <div className="mt-10px">
                                            <p className="text-16 text-red mb-15px">{repairStepName}</p>
                                            <p className="font-weigtht-500 mb-0px">{repairStepDescription}</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                            }
                            {(this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCenter || this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine1 || this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine2 || this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreContactNumber || this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreEmail) &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col-12 col-lg-6 col-md-6 nopa">
                                            <p className="card-subheading mb-0px">Repair centre</p>
                                        </div>
                                        <div className="col-12 col-lg-6 col-md-6 nopa text-lg-right mobile-mt-10px">
                                            {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCenter && <p className="text-red mb-12px">{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCenter}</p>}
                                            {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine1 && <p className="mb-0px">{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine1}</p>}
                                            {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine2 && <p className="mb-0px">{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine2}</p>}
                                            {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreContactNumber && <p className="mb-0px">{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreContactNumber}</p>}
                                            {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreEmail && <p className="mb-0px line-height-normal"><a href={this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreEmail} target="_blank" className="email">{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreEmail}</a></p>}
                                            {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreLat && this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreLong &&
                                                <><button className="btn btn-solid-green font-size-12px pull-lg-right button-width-height mt-20px" onClick={this.handleDirectionsClick}>Get directions</button></>}
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                            }
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa">
                                        <p className="next-step-subheading mb-0">Next step</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <ClaimsNextStep />
                            </div>
                        </div>
                    </Card>}
                    {this.props.claimSubmit.selectedClaimProgressStep.isComplete &&
                        <Card className="content-box-padding-20px-with-box-shadow">
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="claims-noc-step-header-icon-area">
                                            <img src="/my-policy/Images/Claims/Numbers/step-success-32x32px.svg" alt="Step 6" title="Step 6: Completed" />
                                        </div>
                                        <div className="col nopa claims-noc-step-header-title-area">
                                            <h3>Repairs</h3>
                                        </div>
                                    </div>
                                    <p className="font-weight-500 mt-15px mb-0px">Repairs = done</p>
                                    <hr className="mt-20px mb-15px claims-v2-hr-2px" />
                                </div>
                                {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairStatus &&
                                    <div className="col-12 nopa">
                                        <div className="row noma">
                                            <div className="col-12 nopa">
                                                <p className="card-subheading mb-0px">Where we’re at</p>
                                            </div>
                                            <div className="mt-10px">
                                                <p className="text-16 text-red mb-15px">{repairStepName}</p>
                                                <p className="font-weigtht-500 mb-0px">{repairStepDescription}</p>
                                            </div>
                                        </div>
                                        <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                    </div>
                                }
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col-lg-6 col-12 nopa">
                                            <p className="card-subheading">Pay your excess of</p>
                                        </div>
                                        <div className="col-lg-6 col-12 nopa text-lg-right">
                                            <p className="text-red card-subheading">{this.props.profile.currencySymbol}&nbsp;{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairExcess}</p>
                                            <p className="mb-0px">Pay this amount directly to the repairer</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                                {this.getFormatAssesmentDate(this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.claimRepairDate) !== "Not Found" &&
                                    <div className="col-12 nopa">
                                        <div className="row noma">
                                            <div className="col-lg-6 col-12 nopa">
                                                <p className="card-subheading">Ready for collection</p>
                                            </div>
                                            <div className="col-lg-6 col-12 nopa text-lg-right">
                                                <p className="text-red">{this.getFormatAssesmentDate(this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.claimRepairDate)}</p>
                                            </div>
                                        </div>
                                        <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                    </div>
                                }
                                {(this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCenter || this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine1 || this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine2 || this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreContactNumber || this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreEmail) &&
                                    <div className="col-12 nopa">
                                        <div className="row noma">
                                            <div className="col-lg-6 col-md-6 col-12 nopa">
                                                <p className="card-subheading mb-0px">Collection centre</p>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-12 nopa text-lg-right mobile-mt-10px">
                                                {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCenter && <p className="text-red mb-12px">{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCenter}</p>}
                                                {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine && <p className="mb-0px">{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine1}</p>}
                                                {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine2 && <p className="mb-0px">{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.physicalAddressLine2}</p>}
                                                {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreContactNumber && <p className="mb-0px">{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreContactNumber}</p>}
                                                {this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreEmail && <p className="mb-0px line-height-normal"><a href={this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreEmail} target="_blank" className="email">{this.props.claimSubmit.selectedClaimProgressStep.claimRepairStep.repairCentreEmail}</a></p>}
                                                <button className="btn btn-solid-green font-size-12px pull-lg-right button-width-height mt-20px" onClick={this.handleDirectionsClick}>Get directions</button>
                                            </div>
                                        </div>
                                        <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                    </div>
                                }
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <p className="next-step-subheading mb-0">Next step</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <ClaimsNextStep />
                                </div>
                            </div>
                        </Card>}
                </div>
            </>
        )
    }
}


const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),
        handleRepairsTakingLonger: () => dispatch(showRepairsTakingLonger()),
        handleClaimsBackClick: () => dispatch(getOverview()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Repairs);
